const reloadPromptLocale = {
  reloadPrompt: {
    message: "A new version of the application is available.",
    refresh: "Update",
    dismiss: {
      label: "Later",
      header: "Automatic update",
      message:
        "The application will automatically update tomorrow at {hour}. Do you still want to postpone the update?",
      acceptLabel: "Yes, postpone",
      rejectLabel: "No, update now",
    },
    popover: {
      title: "Update available",
      updateAvailable: "Update available",
      currentVersion: "Current version",
      newVersion: "New version",
      autoUpdateMessage: "The application will automatically update tomorrow at {hour}.",
      cancel: "Cancel",
      updateNow: "Update now",
    },
  },
};

export type ReloadPromptLocale = typeof reloadPromptLocale;
export default reloadPromptLocale;
